/**
 * Panel Name:Product Replen
 * App Name: WalmartWeb
 * Created Date:9/16/2021
 * Author:Aparna.K
 * */


/**
 * PR_PC_01
 * import productreplenaction, productreplenstore,sdiconstants,jquery
 * */
import React, { Component } from 'react';
import * as ProductReplenAction from '../actions/ProductReplenAction';
import ProductReplenStore from '../stores/ProductReplenStore';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import Select from 'react-select';
import { height } from '@material-ui/system';
import { withTranslation, Trans } from 'react-i18next'
import * as MenuAction from '../actions/MenuAction';
import swal from 'sweetalert';
let currentPagePath;
const queryParams = new URLSearchParams(window.location.search)

class ProductReplenComponent extends Component {

    constructor(props) {

        super(props);

        /**
       * Ref: RR_PC_03
       * Set the initial values of the state variables
       */
        this.state = {
            CartData: [],
            TxtItem: "",
            EditIndex: -1,
            EditData: [],
            ItemDetailBoolean: false,
            IteDetail: [],
            ItemDescription: "",
            Vendor: "",
            TxtQty: "",
            BuDD: [],
            BuSelected: [],
            DelItem: "",
            DelLoc: "",
            RushOrderCheck: false,
            LOC_NO: "",
            isFavorited: false,
            CartItemCrib: "",
            DiffCribBoolean: false
        }
    };
    /**
     * RP_PC_04
     * 
     * */
    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        const queryParams = new URLSearchParams(window.location.search)
        const locno = queryParams.get('LOC_NO');

        let BO = {
            Loc_No: locno,
            Session_UserId: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ProductReplenAction.PageLoadAction(BO)
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        ProductReplenAction.getCurrentFavPage(getFavPageBO);
        ProductReplenStore.on('ReplenPageLoad', this.PageLoadResponse.bind(this));
        ProductReplenStore.on('ItemDetail', this.ItemDetailResponse.bind(this));
        ProductReplenStore.on('AddtoCart', this.AddtoCartResponse.bind(this));
        ProductReplenStore.on('PlaceOrder', this.PlaceOrderButtonClickResponse.bind(this));
        ProductReplenStore.on('ItemUpdate', this.ItemUpdateResponse.bind(this));
        ProductReplenStore.on('ItemDelete', this.ItemDeleteResponse.bind(this));
        ProductReplenStore.on('favpage', this.loadFavPageResponse.bind(this));
        ProductReplenStore.on('updateFavPage', this.updateFavPageResponse.bind(this));

    }
    componentWillUnmount() {
        ProductReplenStore.removeListener('ReplenPageLoad', this.PageLoadResponse.bind(this));
        ProductReplenStore.removeListener('ItemDetail', this.ItemDetailResponse.bind(this));
        ProductReplenStore.removeListener('AddtoCart', this.AddtoCartResponse.bind(this));
        ProductReplenStore.removeListener('PlaceOrder', this.PlaceOrderButtonClickResponse.bind(this));
        ProductReplenStore.removeListener('ItemUpdate', this.ItemUpdateResponse.bind(this));
        ProductReplenStore.removeListener('ItemDelete', this.ItemDeleteResponse.bind(this));
        ProductReplenStore.removeListener('favpage', this.loadFavPageResponse.bind(this));
        ProductReplenStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));

    }
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(ProductReplenStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        if (ProductReplenStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(ProductReplenStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(ProductReplenStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        // this.refreshMenu();
    };
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Product Replenishment",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            ProductReplenAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            ProductReplenAction.deleteFavPage(deleteFavPageBO)
        }
    };

    /**
     * RP_PC_05
     * */
    PageLoadResponse = () => {
        const queryParams = new URLSearchParams(window.location.search)
        const locno = queryParams.get('LOC_NO');

        let Response = JSON.parse(ProductReplenStore.PageLoadData);
        let locCart = [];
        locCart = Response.CartData
        this.CartDatamodify(locCart)
        this.setState({ LOC_NO: locno });
        console.log("CartDataPR", locCart)
    }
    /**
    *PR_PC_5.1
    * */
    CartDatamodify = (ds) => {
        let crib = ""
        if (ds != undefined && ds.length != 0) {

            ds.forEach((value, index) => {
                let boolean = false
                if (value.rush == 'Y') {
                    boolean = true
                }
                value.Qty = value.Quantity;
                value.RushOrder = boolean;
                value.edit = false;


            });
            crib = ds[0].Unit
            this.setState({ CartData: ds, CartItemCrib: crib });
        }
        else {
            this.setState({ CartData: [], CartItemCrib: crib })
        }
    }
    /**
     * PR_PC_10
     * */
    ItemDetail = () => {
        let BO = {
            Session_UserId: CookieService.getLocalStorageValues("Session_UserID"),
            TxtItemId: this.state.TxtItem,
            Loc_No: this.state.LOC_NO,
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ProductReplenAction.ItemDetailAction(BO)
    }
    /**
    *PR_PC_11
    * */
    ItemDetailResponse = () => {
        //[9/23/22, Bug - 2697 - To display the error messsage when there is issue in replenishing the item, Dhevanesm R]        
        let Response = JSON.parse(ProductReplenStore.PageLoadData);
      
        let ErrorTable = Response.ErrorTable;
        if (ErrorTable != null && ErrorTable != "" && ErrorTable != undefined) {
            if (ErrorTable.length > 0) {
                if (ErrorTable[0].ReplenishError != null && ErrorTable[0].ReplenishError != "" && ErrorTable[0].ReplenishError != undefined) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: ErrorTable[0].ReplenishError
                    });
                    this.setState({ ItemDescription: "", Price: "", Vendor: "", ItemDetail: [], ItemDetailBoolean: false });
                }
            }
        }
        else {
            if (Response.FlagTable[0].flag == 'False') {
                if (Response.ItemDetail.length > 0) {
                    let BUDD = []
                    Response.BuTable.forEach((value) => {
                        BUDD.push({
                            value: value.BU,
                            label: value.DESCR // WBW-16_PC_08 (2/18/2022)-Aparna
                        });

                    });
                    this.setState({ ItemDescription: Response.ItemDetail[0].description, Price: Response.ItemDetail[0].Price, Vendor: Response.ItemDetail[0].vendor, ItemDetail: Response.ItemDetail[0], ItemDetailBoolean: true, BuDD: BUDD, BuSelected: BUDD[0] })
                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Item already exsit in cart or Item not available"
                    });
                    //   alert("Item already exsit in cart or Item not available")
                    this.setState({ ItemDescription: "", Price: "", Vendor: "", ItemDetail: [], ItemDetailBoolean: false });
                }
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Item already exsit in cart or Item not available"
                });
                // alert("Item already exsit in cart or Item not available")
                this.setState({ ItemDescription: "", Price: "", Vendor: "", ItemDetail: [], ItemDetailBoolean: false });
            }
        }

    }
    /**
     * PR_PC_12
     * */
    EditIconClick = (e, index) => {
        e.preventDefault()
        this.setState({ EditIndex: index });
    }
    /**
     * PR_PC_13
     * */

    onChangeinput = (e, index, lab) => {
        let { CartData } = this.state
        console.log("val1", CartData)
        this.state.EditData.push(CartData[index])
        if (lab == "qty") {
            //[9/20/22, Bug - 2679 - To avoid negative entry in the qty field, Dhevanesm R]
            const re = SDIConstants.quantityRegEX;
            if (re.test(e.target.value) || e.target.value == "") {
                CartData[index].Qty = e.target.value
            }

        }
        else if (lab = "rush") {
            let rushloc = false
            if (CartData[index].RushOrder == false) {
                rushloc = true
            }
            CartData[index].RushOrder = rushloc
        }
        this.setState({ CartData });
    }
    /**
    *PR_PC_14
    * */
    ItemUpdate = (e, index, val) => {
        e.preventDefault()
        if (this.state.CartData[index].Qty != "" && this.state.CartData[index].Qty != 0) {
            let BO = {
                Session_UserId: CookieService.getLocalStorageValues("Session_UserID"),
                Loc_No: this.state.LOC_NO,
                Qty: this.state.CartData[index].Qty,
                ItemId: val.Item,
                RushOrderCheck: this.state.CartData[index].RushOrder,
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")

            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ProductReplenAction.ItemUpdateAction(BO)
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Enter valid quantity"
            });
            //  alert("Enter valid quantity");
        }
    }
    /**
     * PR_PC_15
     * */
    ItemUpdateResponse = () => {
        let Response = JSON.parse(ProductReplenStore.PageLoadData);
        let flagResponse = Response.FlagTable[0].flag
        if (flagResponse == 'False') {
            this.CartDatamodify(Response.CartData)
            this.setState({ EditIndex: -1 });
            let flagmsg = Response.FlagTable[0].msg
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: flagmsg
            });
            //  alert(flagmsg)
            return
        }
        else {
            this.CartDatamodify(Response.CartData)
            this.setState({ EditIndex: -1 });
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error Occured"
            });
            //alert("Error Occured");
            return;
        }
    }
    /*
     * PR_PC_17
     * */
    DeleteIconClick = (e, index, val) => {
        e.preventDefault()
        $('#Delete-popupid').modal('show');
        this.setState({ DelLoc: val.Unit, DelItem: val.Item })
    }
    /**
     * PR_PC_18
     * */
    ItemDelete = (e) => {
        e.preventDefault()
        let BO = {
            Loc_No: this.state.CartItemCrib,
            ItemId: this.state.DelItem,
            Session_UserId: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ProductReplenAction.ItemDeleteAction(BO)
    }
    /**
     * PR_PC_19
     * update:9/30/2021
     * */
    ItemDeleteResponse = () => {
        if (this.state.DiffCribBoolean == false) {
            let Response = JSON.parse(ProductReplenStore.PageLoadData);
            if (Response.FlagTable[0].flag == 'False') {
                $('#Delete-popup-id').modal('hide');
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Deleted successfully"
                });
                //    alert("Deleted Successfully")
                this.CartDatamodify(Response.CartData)
                return false
            }
            else {
                $('#Delete-popup-id').modal('hide');
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Error in deleting the item"
                });
                //  alert("Error in deleting the item");
                return false
            }
        }
        else {
            $('#DiffCribPopup').modal('hide');
            let Response = JSON.parse(ProductReplenStore.PageLoadData);
            if (Response.FlagTable[0].flag == 'False') {
                this.CartDatamodify(Response.CartData)
            }
            this.AddtoCartButtonClick()
        }

    }
    /**
     * PR_PC_16
     * */
    CancelButtonClick = (e, index) => {
        e.preventDefault()
        let { CartData } = this.state
        $('#Delete-popup-id').modal('hide');
        this.setState({ EditIndex: -1, ...this.state.CartData, Qty: "", RushOrder: false })
    }
    /**
     * 
     * */
    ClearButtonClick = (e) => {

        this.setState({ Eidtindex: -1, ItemDescription: "", TxtQty: "", TxtItem: "", Vendor: "", RushOrderCheck: false, ItemDetailBoolean: false, BuSelected: "", BuDD: [] })
    }
    /**
    *RP_PC_20
    */
    DelCancel = (e) => {
        e.preventDefault()
        $('#Delete-popup-id').modal('hide');
        this.setState({ DelLocNo: "", DelItemId: "" })
    }
    /**
     * PR_PC_06
     * update:9/30/2021
     * */
    AddtoCartButtonClick = () => {
        if (this.state.TxtQty == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Enter Qty"
            });
            // alert("Enter Qty");
            return;
        }
        else {
            if (this.state.BuSelected.value == this.state.CartItemCrib || this.state.CartItemCrib == "") {
                let BO = {
                    Loc_No: this.state.LOC_NO,
                    Session_UserId: CookieService.getLocalStorageValues("Session_UserID"),
                    TxtItemId: this.state.TxtItem,
                    TxtQty: this.state.TxtQty,
                    RushOrder: this.state.RushOrderCheck,
                    DrpBU: this.state.BuSelected.value,
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                ProductReplenAction.AddtoCartAction(BO)
            }
            else {
                $('#DiffCribPopup').modal('show');
            }

        }
    }
    /**
     * PR_PC_07
     * */
    AddtoCartResponse = () => {
        let Response = JSON.parse(ProductReplenStore.PageLoadData);
        if (Response.FlagTable[0].flag == 'False') {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Successfully added to cart"
            });
            //alert("Successfully added to cart")
            this.CartDatamodify(Response.CartData)
            this.setState({ Eidtindex: -1, ItemDescription: "", TxtQty: "", TxtItem: "", Vendor: "", RushOrderCheck: false, ItemDetailBoolean: false, BuSelected: "", BuDD: [] })
            return
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error occured"
            });
            // alert("Error occured")
            this.setState({ Eidtindex: -1, ItemDescription: "", TxtQty: "", TxtItem: "", Vendor: "", RushOrderCheck: false, ItemDetailBoolean: false, BuSelected: "", BuDD: [] })

            return;
        }
    }
    /**
    *PR_PC_10
    * */
    OnItemIdChange = (event) => {
        //[9/20/22, Bug - 2679 - To avoid negative entry in the qty field, Dhevanesm R]
        if (event.target.name == "TxtItem") {
            this.setState({ [event.target.name]: event.target.value })
        }
        else if (event.target.name == "TxtQty") {
            const re = SDIConstants.quantityRegEX;
            if ((re.test(event.target.value) && parseInt(event.target.value) > 0) || event.target.value == "") {
                this.setState({ [event.target.name]: event.target.value })
            }
        }
        else {
            let locr = false
            if (this.state.RushOrderCheck == false) {
                locr = true
            }
            this.setState({ RushOrderCheck: locr });
        }

    }

    /**
     * PR_PC_08
     * */
    PlaceOrderButtonClick = () => {
        let BO = {
            Loc_No: this.state.LOC_NO,
            Session_UserId: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ProductReplenAction.PlaceOrerAction(BO)
    }
    /**
     * PR_PC_09
     * */
    PlaceOrderButtonClickResponse = () => {
        let Response = JSON.parse(ProductReplenStore.PageLoadData);
        if (Response.FlagTable[0].flag == 'False') {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Order placed successfully"
            });
            //  alert("Order Placed Successfully")
            this.setState({ CartData: [], CartItemCrib: "", EditIndex: -1, })// WBW-16_PC_06 (2/17/2022) -Aparna
            return
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error occured Try again later"
            });
            // alert("Error occured Try again later")
            return;
        }
    }

    onhandleChange = (event) => {
        console.log("valueRMA", event.name)

        this.setState({ BuSelected: event })

    }
    /**
    *PR_PC_23
    * update:9/30/2021
   **/
    DiffCrib = (cribboolean) => {
        if (cribboolean) {
            $('#DiffCribPopup').modal('hide');
            let BO = {
                Loc_No: this.state.CartItemCrib,
                ItemId: "",
                Session_UserId: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Removeall: true
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ProductReplenAction.ItemDeleteAction(BO)
            this.state.DiffCribBoolean = true;
        }
        else {
            $('#DiffCribPopup').modal('hide');
            this.state.DiffCribBoolean = false;
        }
    }
    /**
    *RP_PC_21
    * */

    BindCartData = () => {
        return this.state.CartData.map((value, index) => {
            let updateflag = false;
            if (this.state.EditIndex == index) {

                updateflag = true


            }
            return (
                <tr key={value.Item}>
                    <td>{index + 1}</td>
                    {updateflag == true ?

                        <td> <div className=" ml-4 px-0 float-left">
                            <div className="custom-control wrap-text custom-checkbox  mt-0 item-custom-control ml-0 float-left">
                                <input type="checkbox" className="custom-control-input" id={`Rushorderid` + index} checked={value.RushOrder} onChange={e => this.onChangeinput(e, index, "rush")} />

                                {/*  <input type="checkbox" id={`Rushorderid` + index} className="custom-control-input" value={value.RushOrder} onChange={(e) => this.onChangeinput(e, index, "rush")} />*/}
                                <label className="custom-control-label pl-2 pt-1 catalog-label text-content space-check" htmlFor={`Rushorderid` + index}><Trans>Rush Order</Trans></label>
                            </div>
                        </div></td> :
                        <td>{value.rush}</td>}
                    <td className>{value.Unit}</td>
                    <td className>{value.Item}</td>
                    <td className="space-check">{value.Description}</td>
                    <td className="space-check">{value.Vendor}</td>
                    {updateflag == true ?
                        //[9/20/22, Bug - 2679 - Changed the qty field as text box, Dhevanesm R]
                        <td className><input type="text" className="form-control " value={value.Qty} id={`qtyid` + index} name="TxtQty" onChange={(e) => this.onChangeinput(e, index, "qty")} /></td> :
                        <td className>{value.Quantity}</td>}
                    <td className="text-right">{value.Cost}</td>
                    <td className="text-right">{value.Total}</td>
                    {updateflag == true ?
                        <td className="text-center px-0"><span onClick={e => this.ItemUpdate(e, index, value)}><img className="px-1" src="Images/save-icon.svg" alt="save" title="Save" style={{ height: '25px' }} /></span><span onClick={e => this.CancelButtonClick(e, index)}><img src="Images/cancel-icon.svg" alt="Cancel" title="Cancel" style={{ height: '25px' }} /></span></td> :
                        <td className="text-center px-0"><span onClick={(e) => this.EditIconClick(e, index)}><img className="px-1" src="Images/Edit-icon.svg" alt="edit" style={{ height: '25px' }} /></span><span onClick={(e) => this.DeleteIconClick(e, index, value)} ><img src="Images/delete-icon.svg" alt="delete" title="Delete" style={{ height: '25px' }} /></span></td>}
                </tr>
            );
        })
    }
    render() {
        return (
            <React.Fragment>
                <div className="container-fluid content-section px-0" style={{ marginTop: "145px" }}>{/*parent container*/}
                    <div className="row mx-0 ">
                        <div className="col-lg-12 float-left px-0">
                            <div className="col-md-12 page-heading mb-3 float-left p-0">
                                <h5 className="page-title px-3"><Trans>Product Replenishment</Trans></h5>
                                <div className="fav-item-maintenance-icon mt-1">
                                    <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                    <label htmlFor="checkbox-OrdStatus">
                                        <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                            <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                <g className="grp7" opacity={0} transform="translate(7 6)">
                                                    <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                    <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                </g>
                                                <g className="grp6" opacity={0} transform="translate(0 28)">
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                </g>
                                                <g className="grp3" opacity={0} transform="translate(52 28)">
                                                    <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                    <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                </g>
                                                <g className="grp2" opacity={0} transform="translate(44 6)">
                                                    <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp5" opacity={0} transform="translate(14 50)">
                                                    <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp4" opacity={0} transform="translate(35 50)">
                                                    <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp1" opacity={0} transform="translate(24)">
                                                    <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                    <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                </g>
                                            </g>
                                        </svg>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 float-left mt-3">{/*item section starts*/}
                            <div className="row mx-2 ">
                                <div className="col-md-12 col-lg-12  mt-3 px-0 float-left">{/*parent for item first section*/}
                                    <div className="col-lg-3 col-md-4 px-0 float-left">
                                        <label htmlFor="item-high" className="catalog-label w-100"><Trans>ItemKey</Trans></label>
                                        <div className="input-group charge-code-group float-left mr-2 mb-2">
                                            <input type="text" id="item-high" className="form-control charge-code-control charge-code-control-search" placeholder="Enter Item" name="TxtItem" onChange={e => this.OnItemIdChange(e)} value={this.state.TxtItem} maxLength="9" />
                                            {/* PC-4154-01 06/12/2024 S.Sanjay */}
                                            {this.state.TxtItem.length > 0 && this.state.TxtItem != null && this.state.TxtItem != "" && this.state.TxtItem != " " ?
                                                < span class="search-cancel-header cursor-pointer" style={{ right: "37px" }} onClick={() => this.ClearButtonClick()} ></span> : null
                                            }
                                            <div className="input-group-append" onClick={e => this.ItemDetail()}>
                                                <span className="input-group-text">
                                                    <span className="shopping-search-icon" />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.ItemDetailBoolean ?
                                        <div className="col-lg-2 col-md-4 float-left px-0  mb-3">
                                            <label htmlFor="unitbus" className="catalog-label w-100"><Trans>Business</Trans><span> </span><Trans>Unit</Trans></label>
                                            <Select
                                                className="DropDown-Font-Size"
                                                options={this.state.BuDD}
                                                value={this.state.BuSelected}
                                                onChange={e => this.onhandleChange(e)}
                                                name="SearchBy"
                                            />
                                        </div> : null}
                                    {/*item first section ends*/}
                                </div>
                                {this.state.ItemDetailBoolean ?
                                    <div className="col-md-12 float-left px-0 mt-2 mb-2 ">
                                        <label className="catalog-label"><Trans>Description</Trans><span> :</span></label>
                                        <label className="item-details-value ml-1 text-content ">{this.state.ItemDescription}</label>
                                    </div> : null}
                                {this.state.ItemDetailBoolean ?
                                    <div className="col-md-12 col-lg-12 float-left px-0">
                                        {/*second section 1-part starts*/}
                                        <div className="col-md-5 col-lg-4 float-left px-0 mt-2 mb-2 ">
                                            <label className="catalog-label"><Trans>Vendor</Trans><span> :</span></label>
                                            <label className="item-details-value ml-1 text-content ">{this.state.Vendor}</label>
                                        </div>
                                        <div className="col-md-2 float-left p-0 mt-2 mb-2 ">
                                            <label className="catalog-label"><Trans>Price</Trans><span> :</span></label>
                                            <label className="item-details-value ml-1">{this.state.Price}</label>
                                        </div>{/*second section 1-part ends*/}
                                        <div className=" col-md-3 col-lg-3 float-left p-0">
                                            <label htmlFor="quantity" className=" catalog-label float-left samsung-margin m-2"><Trans>ItemKey</Trans><span> QTY :</span></label>
                                            <input type="text" id="quantity" className="form-control float-left mr-2 catalog-inline-qty" name="TxtQty" maxLength="5" value={this.state.TxtQty} onChange={e => this.OnItemIdChange(e)} />
                                        </div>
                                        <div className="col-md-2 col-lg- 5 px-0 float-left samsung-wrap">
                                            <div className="custom-control custom-checkbox  mt-0 item-custom-control ml-0 float-left">
                                                <input type="checkbox" className="custom-control-input" id="customCheck-16a" name="example1" name="RushOrderCheck" value={this.state.RushOrderCheck} onChange={e => this.OnItemIdChange(e)} />
                                                <label className="custom-control-label catalog-label pt-1 padding-sam " htmlFor="customCheck-16a"><Trans>Rush Order</Trans></label>
                                            </div>
                                        </div>
                                    </div> : null}{/* second section 1-part ends*/}
                                {/*button structure starts*/}
                                <div className="col-md-12  mt-4 mb-3 border-bottom float-left pb-4 px-0">
                                    {this.state.ItemDetailBoolean ? <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={e => this.AddtoCartButtonClick()}><Trans>Add To Cart</Trans></button> : null}
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-3" onClick={e => this.ClearButtonClick()}><Trans>Cancel</Trans></button>
                                </div>
                                {/*button structure ends*/}
                            </div>
                            {/*grid structure data starts*/}
                            {this.state.CartData.length > 0 ?
                                <div className="col-lg-12 px-0">
                                    <div className=" font-format float-left my-3">
                                        <Trans>Items currently in Cart</Trans>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table ZEUS_Grid FOM-grid chk-ordertbl samsung-wrap">
                                            <thead>
                                                <tr>
                                                    <th className="width-google-pixel"><Trans>Line</Trans><span> No</span></th>
                                                    <th className=" width-google-pixel "><Trans>Rush Order</Trans></th>
                                                    <th className=" width-google-pixel "><Trans>Unit</Trans></th>
                                                    <th className="width-google-pixel"><Trans>ItemKey</Trans><span> No</span></th>
                                                    <th className="width-google-pixel border-filter-style space-check"><Trans>Description</Trans></th>
                                                    <th className="width-google-pixel  border-filter-style space-check"><Trans>Vendor</Trans></th>
                                                    <th className="width-set width-google-pixel"><Trans>Quantity</Trans></th>
                                                    <th className="text-right width-google-pixel"><Trans>Cost</Trans></th>
                                                    <th className="text-right width-google-pixel"><Trans>Total</Trans></th>
                                                    <th className=" width-google-pixel text-center"><Trans>Action</Trans></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.BindCartData()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div> : null}
                            {this.state.CartData.length > 0 ?
                                <div className="col-md-12  mt-3 mb-3 border-bottom float-left pb-4 px-0">
                                    <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={e => this.PlaceOrderButtonClick()}><Trans>Place Order</Trans></button>
                                </div> : null}
                        </div>
                    </div>
                </div>
                <div className="modal" id="Delete-popupid" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon delete-confirm-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                        <label className="confirm-content d-block"><Trans>Do you want to remove this item?</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={e => this.DelCancel(e)}><Trans>No</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={(e) => this.ItemDelete(e)}><Trans>Yes</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal" id="DiffCribPopup" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon delete-confirm-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                        <label className="confirm-content d-block"><Trans>Items from different Inventory Business Units cannot be added to same cart</Trans></label>
                                        <label className="confirm-content d-block"><Trans>Do you want to clean the cart?</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={e => this.DiffCrib(false)}><Trans>No</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={(e) => this.DiffCrib(true)}><Trans>Yes</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }


}
export default withTranslation()(ProductReplenComponent);
